var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import React from 'react';
var Radio = function (_a) {
    var checked = _a.checked, color = _a.color, props = __rest(_a, ["checked", "color"]);
    var c = checked ? color : '#999';
    return (React.createElement("svg", __assign({ viewBox: "0 0 27 27", width: "100%", height: "100%" }, props),
        React.createElement("g", { fill: c },
            React.createElement("circle", { className: "border", fill: "none", stroke: c, cx: "12.5", cy: "12.5", r: "12" }),
            checked && React.createElement("circle", { className: "circle", cx: "12.5", cy: "12.5", r: "8" }))));
};
Radio.defaultProps = {
    checked: false,
    color: '#00C1B1',
};
export default Radio;
//# sourceMappingURL=Radio.js.map